"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var participation_info_1 = require("../../components/member/participation-info");
var renderParticipants = function (seasonParticipants) {
    if ((seasonParticipants === null || seasonParticipants === void 0 ? void 0 : seasonParticipants.length) > 0) {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "Panel-row" },
                React.createElement("div", { className: "Grid Grid--fit Grid--withGutter" },
                    React.createElement("div", { className: "Grid-cell" },
                        React.createElement("p", { className: "u-pad u-textSemiBold" }, "Program")),
                    React.createElement("div", { className: "Grid-cell" },
                        React.createElement("p", { className: "u-pad u-textSemiBold" }, "Team/Division")),
                    React.createElement("div", { className: "Grid-cell" },
                        React.createElement("p", { className: "u-pad u-textSemiBold" }, "Role")),
                    React.createElement("div", { className: "Grid-cell" },
                        React.createElement("p", { className: "u-pad u-textSemiBold" }, "Registration")))),
            seasonParticipants.map(function (seasonParticipant) {
                return React.createElement("div", { className: "Panel-row" },
                    React.createElement(participation_info_1.default, { seasonParticipant: seasonParticipant, key: "participation-info-" + seasonParticipant.id }));
            }));
    }
    else {
        return React.createElement("div", { className: "Panel-row" }, "There are no programs for this member.");
    }
};
var MemberParticipationOverview = function (_a) {
    var orgId = _a.orgId, memberId = _a.memberId, seasonParticipants = _a.seasonParticipants;
    return (React.createElement("div", { className: "Panel Panel--striped" },
        React.createElement("div", { className: "Panel-body" }, renderParticipants(seasonParticipants))));
};
exports.default = MemberParticipationOverview;
//# sourceMappingURL=member-participation-overview.js.map